import { render, staticRenderFns } from "./QuestionComp.vue?vue&type=template&id=3d579488&"
import script from "./QuestionComp.vue?vue&type=script&lang=js&"
export * from "./QuestionComp.vue?vue&type=script&lang=js&"
import style0 from "./QuestionComp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports